import { Dispatch } from 'redux';
import { CommonDeal } from 'components/common/types/Deal.types';
import { DirectSalesLine } from 'components/common/types/DirectSalesCampaign.types';
import { Store } from 'components/common/types/Store.types';
import { setLoadedDirectSalesData } from 'store/dealManagement/reducer';

export type SetLoadedDirectSalesDataPayload = {
  commonDeal: Partial<CommonDeal>;
  lines: Partial<DirectSalesLine>[];
};

export const setLoadedDirectSalesDataWithPublisherDefaults =
  (payload: SetLoadedDirectSalesDataPayload) =>
  (dispatch: Dispatch, getState: () => Store): void => {
    dispatch(
      setLoadedDirectSalesData({
        ...payload,
        campaignConfiguration: getState().publisher.campaignConfiguration,
      }),
    );
  };
